export const middleEllipsis = (str: string): string =>
  (str && `${str.substr(0, 6)}...${str.substr(str.length - 4, str.length)}`) || str;
